import * as React from 'react';

const useStateWithCallback = <S>(initialValue: S) => {
  type CallBack = (newState: S) => void;
  type Setter = (newState: Partial<S>, cb?: CallBack) => void;
  const callbackRef = React.useRef<CallBack | null>(null);

  const [value, setValue] = React.useState<S>(initialValue);

  React.useEffect(() => {
    if (callbackRef.current) {
      callbackRef.current(value);

      callbackRef.current = null;
    }
  }, [value]);

  const setValueWithCallback: Setter = React.useCallback(
    (newValue, callback) => {
      if (callback) callbackRef.current = callback;

      return setValue((prev) => ({ ...prev, ...newValue }));
    },
    [],
  );

  return [value, setValueWithCallback] as const;
};

export default useStateWithCallback;
